(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/play/play.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/play/play.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const GameLauncherWrapper = svs.tickets.next.areas.play.containers.GameLauncherWrapper;
const _React = React,
  useState = _React.useState;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils,
  useScratchDefaultEventsLeiaFactory = _svs$ticketgames$tick.useScratchDefaultEventsLeiaFactory,
  showDialog = _svs$ticketgames$tick.showDialog,
  tracking = _svs$ticketgames$tick.tracking;
const NavigationBack = svs.tur.NavigationBack;
const getPositiveIntegerParam = key => {
  const value = svs.utils.paramHandler.get({
    key
  }).value;
  const parsedValue = parseInt(value, 10);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
};
const Play = _ref => {
  var _svs$tickets$data$mod;
  let history = _ref.history,
    location = _ref.location,
    match = _ref.match;
  const _ref2 = (match === null || match === void 0 ? void 0 : match.params) || {},
    ticketType = _ref2.ticketType,
    wagerId = _ref2.wagerId;
  const isDemo = wagerId === 'demo';
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGameExpanded = _useState2[0],
    setIsGameExpanded = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCardFlipped = _useState4[0],
    setIsCardFlipped = _useState4[1];
  const availableTickets = ((_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.availableTickets) || [];
  const ticketInfo = availableTickets.find(ticket => {
    var _ticket$alternativeUr;
    return ticket.type.toLowerCase() === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase()) || ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase());
  });
  const ticketNumber = getPositiveIntegerParam('ticketNumber');
  const skinIdFromTicketNumber = ticketNumber && ticketInfo ? svs.tickets.next.utils.utils.getSelectedTicketVariation(ticketNumber, ticketInfo) : null;
  const skinId = ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin ? 1 : skinIdFromTicketNumber || getPositiveIntegerParam('skinId') || 1;
  const handleBack = () => {
    history.push("/valja/".concat(ticketType));
  };
  const currentPath = (location === null || location === void 0 ? void 0 : location.pathname) || window.location.pathname;
  const routes = {
    [currentPath]: {
      text: "".concat(ticketType, " "),
      navigate: () => history.push("/valja/".concat(ticketType))
    }
  };
  const _useScratchDefaultEve = useScratchDefaultEventsLeiaFactory({
      demo: isDemo,
      ticketInfo,
      test: false,
      shouldShowConfetti: false
    }),
    gameResult = _useScratchDefaultEve.gameResult,
    soundStatus = _useScratchDefaultEve.soundStatus,
    notifySoundStatus = _useScratchDefaultEve.notifySoundStatus;
  const handleGameLoaded = () => {};
  if (!ticketInfo) {
    return React.createElement("div", null, "Lotten kunde inte hittas");
  }
  const topBarTrackingLabel = tracking.createTopBarTrackingLabel({
    isDemo,
    location: wagerId && !isDemo ? 'mina-spel' : 'spela',
    gameCode: ticketInfo.type
  });
  return React.createElement("div", {
    className: "w100 h100"
  }, React.createElement(NavigationBack, {
    brand: "next-lobby",
    routes: routes
  }), React.createElement(GameLauncherWrapper, {
    demo: isDemo,
    history: history,
    isCardFlipped: isCardFlipped,
    onClose: handleBack,
    onExpandChange: isExpanded => {
      setIsGameExpanded(isExpanded);
    },
    onGameLoaded: handleGameLoaded,
    skinId: skinId,
    ticketInfo: ticketInfo,
    ticketNumber: ticketNumber,
    topBarProps: {
      isSoundOn: soundStatus,
      onClose: () => {
        var _gameResult$amount;
        showDialog({
          type: 'close',
          isDemo,
          onClose: handleBack,
          trackingData: {
            label: topBarTrackingLabel,
            value: (_gameResult$amount = gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount) !== null && _gameResult$amount !== void 0 ? _gameResult$amount : -1
          }
        });
      },
      onSoundClick: () => {
        notifySoundStatus(!soundStatus);
      },
      onInfoClick: () => {
        if (isGameExpanded) {
          return;
        }
        setIsCardFlipped(prev => !prev);
      },
      trackingLabel: topBarTrackingLabel
    },
    wagerId: wagerId
  }));
};
setGlobal('svs.tickets.next.areas.play.Play', Play);

 })(window);